import { render } from "./UserData.vue?vue&type=template&id=35f88d08&scoped=true&ts=true"
import script from "./UserData.ts?vue&type=script&lang=ts"
export * from "./UserData.ts?vue&type=script&lang=ts"

import "./UserData.vue?vue&type=style&index=0&id=35f88d08&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f88d08"]])

export default __exports__